import { Injectable } from '@angular/core';

import { Observable, observableOf, rx } from '@app/shared/rx/rx-wrapper';
import { TranslationService } from '@app/shared/services/i18n';
import { Subject } from 'rxjs';

@Injectable()
export class TranslationGuard {
  public translationInitialized$: Subject<boolean> = new Subject();

  /**
   * use this to check if the translation guard has been initialized
   * this is used to prevent multiple initializations of the guard
   */
  public static isInitialized = false;

  public constructor(public translationService: TranslationService) {}

  public canActivate(): Observable<boolean> {
    if (TranslationGuard.isInitialized) {
      return observableOf(true);
    }

    TranslationGuard.isInitialized = true;

    return this.translationService.translationInitialized$.pipe(
      rx.first(),
      rx.switchMap(() => observableOf(true)),
    );
  }
}
